export default __webpack_public_path__ + "static/media/YesButton.73b8e86e.png";